import classNames from 'classnames';
import { formatCurrency } from 'lib/helpers/strings';
import usePublicRuntimeConfig from 'modules/common/hooks/usePublicRuntimeConfig';
import React from 'react';
// import NumberComponent, { formatCurrency } from 'modules/common/components/Number';
// import { useRouter } from 'next/router';

type HowDoesItWorkProps = {
  platformFees: number;
  bounty: number;
  mySearch?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const HowDoesItWork: React.FC<HowDoesItWorkProps> = ({ children, mySearch, className, bounty, platformFees, ...props }) => {
  // const router = useRouter();
  const { siteName } = usePublicRuntimeConfig();
  return (
    <div className={classNames('max-w-xs', className)} {...props}>
      {mySearch ? (
        <>
          <p>Tu reçois des propositions de missions pour ton candidat par d’autres consultants.</p>
          <p className="mt-2">Tu autorises le consultant à proposer ton candidat à ses clients.</p>
          <p className="mt-2">
            Si le candidat est placé, tu es payé du montant de la prime que tu as renseignée{' '}
            <strong>{formatCurrency({ value: bounty, locale: 'fr' })}</strong>. Le consultant devra s’acquitter en + de la commission {siteName} de{' '}
            <strong>{formatCurrency({ value: bounty * platformFees, locale: 'fr' })}</strong>.
          </p>
          <p className="mt-2">{siteName} se charge de la facturation et des paiements.</p>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            {bountyStart && (
              <div className="mt-1 text-left">
                <ul>
                  <p className="ml-3">
                    + la commission HL de{' '}
                    <strong>
                      {formatCurrency({ value: bountyStart * platformFees, locale: router.locale, precision: 2 })} (
                      <NumberComponent percent value={platformFees} />)
                    </strong>
                  </p>
                  <p className="ml-3">
                    Total de <strong>{formatCurrency({ value: bountyStart * (1 + platformFees), locale: router.locale, precision: 2 })} </strong>
                  </p>
                </ul>
              </div>
            )}
          </div> */}
        </>
      ) : (
        <>
          <p>Tu proposes une mission en transmettant les informations sur celle-ci au consultant en ayant le candidat Off-Market.</p>
          <p className="mt-2">
            Si ce candidat est recruté/placé par toi ou l’un de tes collaborateurs, pour cette mission ou une autre mission, tu devras payer la prime
            selon les modalités définies:
            <br />
            <ul>
              <li>
                <strong>{formatCurrency({ value: bounty, locale: 'fr' })}</strong> au recruteur
              </li>
              <li>
                <strong>{formatCurrency({ value: bounty * platformFees, locale: 'fr' })}</strong> à {siteName} pour les frais
              </li>
            </ul>
          </p>
        </>
      )}
    </div>
  );
};

export default HowDoesItWork;
